import { render } from "./IntellifloOfficeClientFileReviewsComponent.vue?vue&type=template&id=e1e9e9ca&scoped=true"
import script from "./IntellifloOfficeClientFileReviewsComponent.vue?vue&type=script&lang=js"
export * from "./IntellifloOfficeClientFileReviewsComponent.vue?vue&type=script&lang=js"

import "./IntellifloOfficeClientFileReviewsComponent.vue?vue&type=style&index=0&id=e1e9e9ca&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e9e9ca"]])

export default __exports__